module.exports = __webpack_public_path__ + "img/mojito.828cb29b.jpg";